import { BillEventSchema, InvoiceEventSchema } from '@eigtech/invoicing-types';
import { JobEventSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { TimelineAssignmentsEventSchema } from './assignments.js';
import { InspectionsInspectionTimelineEventSchema } from './inspectionsChronicles.js';
export const JobTimelineEventSchema = z.union([
    BillEventSchema,
    InvoiceEventSchema,
    InspectionsInspectionTimelineEventSchema,
    JobEventSchema,
    TimelineAssignmentsEventSchema,
]);
